// src/store/exportedFrames.js
import React, { createContext, useContext, useReducer } from "react";

const ExportedFramesContext = createContext(undefined);

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD_FRAMES": {
      const ids = new Set(state.map((f) => f.id));
      return [...state, ...action.payload.filter((f) => !ids.has(f.id))];
    }
    case "CLEAR":
      return [];
    default:
      return state;
  }
};

export const ExportedFramesProvider = ({ children }) => {
  const [frames, dispatch] = useReducer(reducer, []);

  const addFrames = (payload) => dispatch({ type: "ADD_FRAMES", payload });
  const clear = () => dispatch({ type: "CLEAR" });

  return (
    <ExportedFramesContext.Provider value={{ frames, addFrames, clear }}>
      {children}
    </ExportedFramesContext.Provider>
  );
};

export const useExportedFrames = () => {
  const ctx = useContext(ExportedFramesContext);
  if (!ctx) throw new Error("useExportedFrames must be used inside ExportedFramesProvider");
  return ctx;
};
